export default "__VITE_ASSET__BvpnWG4X__"